const ERROR_CODE = {
  INVALID_OTP: 'E601',
  // email errors
  EMAIL_ALREADY_REGISTERED: 'E132',
  INVALID_EMAIL: 'E112',
  // password errors
  INVALID_PASSWORD: 'E133',
  PASSWORD_LENGTH_TOO_SMALL: 'E114',
  // name errors
  PROFANE_CONTENT_USED: 'E164',
  USED_SPL_CHAR_IN_NAME: 'E161'
};

const getErrorMessage = (isError, error) =>
  isError ? error?.message || '' : '';

export const getEmailError = (error) => {
  const isEmailError =
    [ERROR_CODE.INVALID_EMAIL, ERROR_CODE.EMAIL_ALREADY_REGISTERED].includes(
      error?.code
    ) || false;
  return {
    isEmailError,
    emailErrorMsg: getErrorMessage(isEmailError, error)
  };
};

export const getNameError = (error) => {
  const isNameError =
    [
      ERROR_CODE.PROFANE_CONTENT_USED,
      ERROR_CODE.USED_SPL_CHAR_IN_NAME
    ].includes(error?.code) || false;
  return {
    isNameError,
    nameErrorMsg: getErrorMessage(isNameError, error)
  };
};

export const getOtpError = (error) => {
  const isOtpError = error?.code === ERROR_CODE.INVALID_OTP || false;
  return {
    isOtpError,
    otpErrorMsg: getErrorMessage(isOtpError, error)
  };
};

export const getPasswordError = (error) => {
  const isPasswordError =
    [
      ERROR_CODE.INVALID_PASSWORD,
      ERROR_CODE.PASSWORD_LENGTH_TOO_SMALL
    ].includes(error?.code) || false;
  return {
    isPasswordError,
    passwordErrorMsg: getErrorMessage(isPasswordError, error)
  };
};
